module.exports = __webpack_public_path__ + "static/media/approvedstamp.f25553d6.svg";